import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "@app/env";
import { Observable } from "rxjs/Observable";
import { catchError, retry, tap } from "rxjs/operators";
import { Utilities } from "./utilities";

export const _TRACKING_ENTITIES = {
  CATALOG: "CATALOG",
  CLIENT: "CLIENT",
  COMMERCIAL_SAMPLE: "COMMERCIAL_SAMPLE",
  COUPONS: "COUPONS",
  EVENT: "EVENT",
  EVENT_COMMERCIAL_SAMPLE: "EVENT_COMMERCIAL_SAMPLE",
  NEWS: "NEWS",
  NEWS_EVENT: "NEWS_EVENT",
  RESERVE: "RESERVE",
  SERVICE: "SERVICE",
  SPONSOR: "SPONSOR",
  STAFF: "STAFF",
  TICKET: "TICKET",
  USERS: "USERS",
};

@Injectable()
export class TrackingProvider {

  constructor(
    private http: HttpClient,
    private utilities: Utilities,
  ) { }

  public trackEntity(entityType: string, entityId: string, client: string, payload: any) {
    const entity = {
      client,
      entity_id: entityId,
      entity_type: entityType,
      payload,
      timestamp: new Date().getTime(),
    };
    return this.http.post(`${ENV.ia_api_url}/records`, entity)
      .pipe(retry(3), catchError((err) => [this.utilities.consoleDecorator("Error tracking: ", err, "purple")]))
      .subscribe((data) => this.utilities.consoleDecorator("Tracking: ", entity, "purple"));
  }

  public trackEntityPromise(entityType: string, entityId: string, client: string, payload: any) {
    const entity = {
      client,
      entity_id: entityId,
      entity_type: entityType,
      payload,
      timestamp: new Date().getTime(),
    };
    return this.http.post(`${ENV.ia_api_url}/records`, entity)
      .pipe(retry(3), catchError((err) => [this.utilities.consoleDecorator("Error tracking: ", err, "purple")]))
      .toPromise()
      .then((data) => this.utilities.consoleDecorator("Tracking: ", entity, "purple"));
  }

  public findEntityById(clientId: string, entityId: string, type: "catalog" | "event"): Observable<any> {
    return this.http.get(`${ENV.ia_api_url}/coverage?client_id=${clientId}&entity_id=${entityId}&type=${type}`)
      .do((result) => this.utilities.consoleDecorator(`Finding ${type} data by id`, result, "#4a148c"));
  }

  public trackingMetadata(clientId: string, entityId: string, entityType: string, index: any, payload: any) {
    return this.http.post(`${ENV.backendV5}/metadata/create`, {
      client_id: clientId,
      entity_id: entityId,
      entity_type: entityType,
      index,
      payload,
    }).pipe(
      tap((result) => this.utilities.consoleDecorator(`Send metadata tracking for search pages`, result, "#4a148c")),
    ).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/providers/tracking.ts